import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("bonacasa AG")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginComponent = _resolveComponent("LoginComponent")!
  const _component_n_tab_pane = _resolveComponent("n-tab-pane")!
  const _component_n_tabs = _resolveComponent("n-tabs")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_layout_content = _resolveComponent("n-layout-content")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_layout_footer = _resolveComponent("n-layout-footer")!
  const _component_n_layout = _resolveComponent("n-layout")!

  return (_openBlock(), _createBlock(_component_n_layout, {
    embedded: "",
    "content-style": "display: flex; align-items: center; height: 100vh; padding: 24px;"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_n_tabs, {
                class: "card-tabs",
                "default-value": "signin",
                size: "large",
                animated: "",
                style: {"margin":"0 -4px"},
                "pane-style": "padding-left: 4px; padding-right: 4px; box-sizing: border-box;"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_tab_pane, {
                    name: "signin",
                    tab: "Eintragen"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LoginComponent)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_n_layout_footer, {
        bordered: "",
        position: "absolute",
        style: {"padding":"12px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_space, { justify: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_n_text, { type: "primary" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}